import { RefObject, useEffect } from 'react'

export const maxWidgetHeight = 400

export const useMeasureWidgetDimensions = (
  ref: RefObject<HTMLDivElement>,
  offset: number,
  onHeightChange?: (height: number) => void
) => {
  useEffect(() => {
    if (!ref.current || !onHeightChange) return

    const observer = new ResizeObserver(() => {
      const height = Math.min(
        ref.current!.offsetHeight + offset,
        maxWidgetHeight + offset
      )

      onHeightChange(height)
    })

    observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [offset, onHeightChange])
}
